import {
    Button,
    Container,
    Dropdown,
    Form,
    FormGroup,
    Input,
    InputPlaceholder,
    Segment,
    SegmentContent,
    SegmentHeader,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Deferred, Link, useForm, usePage } from '@inertiajs/react';
import { useEffect, useMemo } from 'react';
import Rules from './components/Rules';

const CreateOrUpdateView = () => {
    const { calculation, target_groups } = usePage().props;
    const { data, setData, post, patch, errors, processing } = useForm({});

    const title = useMemo(
        () => (calculation?.id ? 'Wijzig berekening' : 'Nieuwe berekening'),
        [calculation]
    );

    useEffect(() => {
        if (calculation?.id) {
            setData(calculation);
        }
    }, [calculation?.id]);

    const handleSubmit = () => {
        if (calculation?.id) {
            patch(`/calculations/${calculation.id}`);

            return;
        }

        post('/calculations');
    };

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Segment>
                    <SegmentHeader header={title}>
                        <Button as={Link} href='/calculations' type='button'>
                            <ArrowLeftIcon className='size-5' />
                            Terug
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <FormGroup equal inline>
                            {!!calculation?.id && (
                                <Input
                                    label='UID'
                                    readOnly
                                    value={data?.unique_id || ''}
                                />
                            )}
                            <Deferred
                                data={['target_groups']}
                                fallback={
                                    <InputPlaceholder
                                        label='Geschikt voor doelgroep'
                                        placeholder='Doelgroepen worden geladen...'
                                    />
                                }
                            >
                                <Dropdown
                                    label='Geschikt voor doelgroep'
                                    options={Object.keys(
                                        target_groups || {}
                                    )?.map(targetGroupId => ({
                                        id: targetGroupId,
                                        name: target_groups[targetGroupId],
                                    }))}
                                    value={data?.target_group_id || ''}
                                    onChange={value =>
                                        setData('target_group_id', value)
                                    }
                                    error={errors?.target_group_id}
                                />
                            </Deferred>
                        </FormGroup>
                        <FormGroup>
                            <Input
                                label='Naam'
                                required
                                value={data?.name || ''}
                                onChange={event =>
                                    setData('name', event.target.value)
                                }
                                error={errors?.name}
                            />
                        </FormGroup>
                    </SegmentContent>
                </Segment>

                <Rules data={data} onChange={setData} />

                <Segment floating>
                    <SegmentContent right>
                        <Button
                            type='submit'
                            variant='primary'
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </SegmentContent>
                </Segment>
            </Form>
        </Container>
    );
};

export default CreateOrUpdateView;
